import { UtenteVO } from "./utenteVO";

export class SettoreVO {
  codice: string;
  nome: string;
  responsabile: string;
  incaricato: UtenteVO;
  output: string;
}
